import { HttpClient } from '@angular/common/http';
import { DomainService } from './domain-service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./domain-service";
var InsuredServiceService = /** @class */ (function () {
    function InsuredServiceService(http, domainService) {
        this.http = http;
        this.domainService = domainService;
    }
    InsuredServiceService.prototype.getByPolicy = function (policySequence) {
        var url = this.domainService.backendUrlWithContext + '/policies/' + policySequence + '/insureds';
        return this.http.get(url).toPromise();
    };
    /**
     * Recupera todos los asegurados de todas las pólizas DJ29 (Asistencia Jurídica Familiar)
     * del usuario logado. Cada asegurado incluye el POLIZSEC de su póliza (policySequence).
     */
    InsuredServiceService.prototype.getAll = function () {
        var url = this.domainService.backendUrlWithContext + '/policies/insureds';
        return this.http.get(url).toPromise();
    };
    InsuredServiceService.prototype.create = function (policySequence, dto) {
        var url = this.domainService.backendUrlWithContext + '/policies/' + policySequence + '/insured';
        return this.http.post(url, dto).toPromise();
    };
    InsuredServiceService.prototype.modify = function (policySequence, dto) {
        var url = this.domainService.backendUrlWithContext + '/policies/' + policySequence + '/insured';
        return this.http.put(url, dto).toPromise();
    };
    InsuredServiceService.prototype.delete = function (policySequence, documentNumber) {
        var url = this.domainService.backendUrlWithContext + '/policies/' + policySequence + '/insured/' + documentNumber;
        return this.http.delete(url).toPromise();
    };
    InsuredServiceService.ngInjectableDef = i0.defineInjectable({ factory: function InsuredServiceService_Factory() { return new InsuredServiceService(i0.inject(i1.HttpClient), i0.inject(i2.DomainService)); }, token: InsuredServiceService, providedIn: "root" });
    return InsuredServiceService;
}());
export { InsuredServiceService };
